import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { ZoneType } from '../../../../types/layout';
import { ModuleType } from '../../../../types/modules';
import { getInstallableModulesForZone } from '../../../selectors/layout';
import { isCurrentUserProfileOwner } from '../../../selectors/users';
import { Props } from './HomeSection';

type StateProps = Pick<Props, 'isOwner' | 'hasMegaboxInstalled'>;
type OwnProps = Omit<Props, keyof StateProps>;

export const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const installableModulesMegaBar = getInstallableModulesForZone(
    state,
    'home',
    ZoneType.MEGA_BAR
  );
  const hasMegaboxInstalled =
    (installableModulesMegaBar.find(
      moduleInfo => moduleInfo.moduleName === ModuleType.MEGABOX
    )?.installedCount || 0) > 0;
  const installableModulesTopRight = getInstallableModulesForZone(
    state,
    'home',
    ZoneType.TOP_RIGHT
  );
  const hasAboutMeInstalled =
    (installableModulesTopRight.find(
      moduleInfo => moduleInfo.moduleName === ModuleType.ABOUT
    )?.installedCount || 0) > 0;
  return {
    isOwner: isCurrentUserProfileOwner(state),
    hasMegaboxInstalled,
    hasAboutMeInstalled,
  };
};

export default connect(mapStateToProps);
